import { brokerAnnouncementsAdminApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

// The list endpoint is gated on the broker-home manage-announcements claim, which
// the page's SYSTEM_PROPERTIES route gate does not imply — a client-tenant admin
// that holds the page permission but lacks the claim 403s. Skip the global
// forbidden interceptor so that surfaces as the page's local error state instead
// of the page-reload loop (mirrors DEV-4195 Client Protection).
const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_ANNOUNCEMENTS_ADMIN_ACTION_TYPE = createNamedActions(
  'commandCenterAnnouncementsAdmin',
  {
    GET_ANNOUNCEMENTS: 'GET_ANNOUNCEMENTS',
    RESET_ANNOUNCEMENTS_STATE: 'RESET_ANNOUNCEMENTS_STATE',
  },
);

export const getCommandCenterAnnouncementsAdminAction = catchAsyncActionError(
  ({ companyId, subCompanyId } = {}) =>
    async dispatch => {
      const { data } = await brokerAnnouncementsAdminApi.getAnnouncements({
        companyId,
        subCompanyId,
        config: SKIP_FORBIDDEN_CONFIG,
      });

      return dispatch({
        type: COMMAND_CENTER_ANNOUNCEMENTS_ADMIN_ACTION_TYPE.GET_ANNOUNCEMENTS,
        payload: data?.announcements ?? [],
      });
    },
);

export const createCommandCenterAnnouncementAction = catchAsyncActionError(
  params => async () => brokerAnnouncementsAdminApi.createAnnouncement(params),
);

export const updateCommandCenterAnnouncementAction = catchAsyncActionError(
  params => async () => brokerAnnouncementsAdminApi.updateAnnouncement(params),
);

export const deleteCommandCenterAnnouncementAction = catchAsyncActionError(
  id => async () => brokerAnnouncementsAdminApi.deleteAnnouncement(id),
);

export const resetCommandCenterAnnouncementsAdminStateAction = () => ({
  type: COMMAND_CENTER_ANNOUNCEMENTS_ADMIN_ACTION_TYPE.RESET_ANNOUNCEMENTS_STATE,
});
